import { useEffect } from "react";

/**
 * SchemaScript — injects a JSON-LD <script> tag into <head> and removes it on unmount.
 * Use this for per-page structured data (FAQPage, Article, BreadcrumbList, etc.)
 */
export default function SchemaScript({ schema }: { schema: object }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema);
    script.setAttribute("data-schema-dynamic", "true");
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [JSON.stringify(schema)]);

  return null;
}
